import Link from 'next/link'

import CornerBackgroundImage from '@/components/Combo/CornerBackgroundImage/CornerBackgroundImage'
import Icon, { EDHRECIconsType } from '@/components/Icon/Icon'
import { artCrop } from '@/utils/images'

import styles from './ComboNavLink.module.scss'

type Props = {
  cornerImageUid?: string
  description: string
  icon: EDHRECIconsType
  title: string
  url: string
}

const ComboNavLink = ({ cornerImageUid, description, icon, title, url }: Props) => (
  <Link className={styles.outerNavLink} href={url}>
    {cornerImageUid && <CornerBackgroundImage image={artCrop(cornerImageUid)} position='bottomRight' size={200} />}
    <h3>
      <Icon icon={icon} /> {title}
    </h3>
    <p className={styles.subText}>{description}</p>
  </Link>
)

export default ComboNavLink
